import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { smithersDeviceService } from "@/services/smithers-device-service"

import type { CreateSmithersDeviceRequest, UpdateSmithersDeviceRequest, SmithersDeviceListParams } from "@/types/smithers-device"
import type { BulkUpdateSmithersDevicesRequest } from "@/types/smithers-device"

export function useSmithersDevices(params: SmithersDeviceListParams = {}, clientPk?: number | null) {
  return useSWR(clientPk === null ? null : ["smithers", "devices", clientPk ?? "all", params], () => clientPk === undefined ? smithersDeviceService.getAll(params) : smithersDeviceService.getByClient(clientPk!, params), {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  })
}

export function useCreateSmithersDevice() {
  return useSWRMutation(["smithers", "devices", "create"], (_key: string[], { arg }: { arg: CreateSmithersDeviceRequest }) => smithersDeviceService.create(arg))
}

export function useSmithersDevice(id?: number) {
  return useSWR(id === undefined ? null : ["smithers", "devices", "detail", id], () => smithersDeviceService.getById(id!), { revalidateOnFocus: false, shouldRetryOnError: false })
}
export function useUpdateSmithersDevice(id?: number) {
  return useSWRMutation(["smithers", "devices", "update", id], (_key, { arg }: { arg: UpdateSmithersDeviceRequest }) => smithersDeviceService.update(id!, arg))
}
export function useDeleteSmithersDevice() {
  return useSWRMutation(["smithers", "devices", "delete"], (_key, { arg }: { arg: number }) => smithersDeviceService.delete(arg))
}

export function useBulkDeleteSmithersDevices() {
  return useSWRMutation(["smithers", "devices", "bulk-delete"], (_key, { arg }: { arg: number[] }) => smithersDeviceService.bulkDelete(arg))
}

export function useBulkUpdateSmithersDevices() {
  return useSWRMutation(["smithers", "devices", "bulk-update"], (_key, { arg }: { arg: BulkUpdateSmithersDevicesRequest }) => smithersDeviceService.bulkUpdate(arg))
}
